<div fxLayout="column" [ngStyle]="{'max-height.px': innerHeight}">

    <div class="scrolled layout-padd">

        <div class="divider layout-padd" fxLayoutAlign="space-between center">
            <span class="mat-title" ngClass.xs="mat-subheading-1">{{'requiredInfoComponent.inforequired'|translate}}</span>
            <mat-icon class="clicked" (click)="logOut()" angulartics2On="click" angularticsAction="logout"
                angularticsCategory="requiredInfo">exit_to_app</mat-icon>
        </div>

        <form fxLayout="column" fxLayoutGap="10px" fxLayoutGap.xs="0" class="layout-padd"
            [formGroup]="requiredInfosForm" #formDirective="ngForm">

            <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0">

                <!-- Firstname input -->
                <mat-form-field fxFlex="30">
                    <mat-label>{{'requiredInfoComponent.firstname'|translate}} </mat-label>
                    <input type="text" matInput placeholder="{{'requiredInfoComponent.firstname'|translate}}" formControlName="firstname">
                    <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('firstname')">
                        <span class="mat-caption">{{'requiredInfoComponent.firstnameRequired'|translate}}</span>
                    </mat-error>
                    <mat-error fxLayout fxLayoutAlign="start center"
                        *ngIf="requiredInfosForm.get('firstname').hasError('nospace')">
                        <span class="mat-caption">{{'requiredInfoComponent.invalidFormat'|translate}}</span>
                    </mat-error>
                </mat-form-field>

                <!-- Lastname input -->
                <mat-form-field fxFlex="30">
                    <mat-label>{{'requiredInfoComponent.name'|translate}}</mat-label>
                    <input type="text" matInput placeholder="{{'requiredInfoComponent.name'|translate}}" formControlName="lastname">
                    <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('lastname')">
                        <span class="mat-caption">{{'requiredInfoComponent.nameRequired'|translate}}</span>
                    </mat-error>
                    <mat-error fxLayout fxLayoutAlign="start center"
                        *ngIf="requiredInfosForm.get('lastname').hasError('nospace')">
                        <span class="mat-caption">{{'requiredInfoComponent.invalidFormat'|translate}}</span>
                    </mat-error>
                </mat-form-field>

                <!-- Phone number input -->
                <mat-form-field fxFlex>
                    <mat-label>{{'requiredInfoComponent.mobile'|translate}}</mat-label>
                    <input type="text" matInput placeholder="{{'requiredInfoComponent.mobile'|translate}}" formControlName="phone">
                    <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('phone')">
                        <span class="mat-caption">{{'requiredInfoComponent.mobileRequired'|translate}}</span>
                    </mat-error>
                    <mat-error fxLayout fxLayoutAlign="start center"
                        *ngIf="requiredInfosForm.controls['phone'].errors?.pattern">
                        <span class="mat-caption">{{'requiredInfoComponent.invalidFormat'|translate}}</span>
                    </mat-error>
                </mat-form-field>

            </div>

            <!-- Address input -->
            <mat-form-field>
                <mat-label>{{'requiredInfoComponent.address'|translate}}</mat-label>
                <input type="text" matInput placeholder="{{'requiredInfoComponent.address'|translate}}" formControlName="address">
                <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('address')">
                    <span class="mat-caption">{{'requiredInfoComponent.addressrequired'|translate}}</span>
                </mat-error>
                <mat-error fxLayout fxLayoutAlign="start center"
                    *ngIf="requiredInfosForm.get('address').hasError('nospace')">
                    <span class="mat-caption">{{'requiredInfoComponent.invalidFormat'|translate}}</span>
                </mat-error>
            </mat-form-field>

            <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0">

                <!-- Country input -->
                <mat-form-field fxFlex="30">

                    <mat-label>{{'requiredInfoComponent.country'|translate}}</mat-label>

                    <input matInput #autoCompleteCountry placeholder="{{'requiredInfoComponent.country'|translate}}" [matAutocomplete]="autoCountries"
                        formControlName="country_name" autocomplete="none|false|no">

                    <mat-autocomplete #autoCountries="matAutocomplete" position="'below'">

                        <ng-container *ngIf="!loaders.countries && filteredCountries">

                            <mat-option *ngFor="let country of filteredCountries" [value]="country.name"
                                (onSelectionChange)="onSelectCountry(country)">

                                <div fxLayout="row" fxLayoutGap="10px">
                                    <div fxLayoutAlign="center center">
                                        <img src="data:image/png;base64,{{country.flag}}"  class="h-10">
                                    </div>
                                    <div fxLayoutAlign="center center">
                                        <span>{{country.name}}</span>
                                    </div>
                                </div>

                            </mat-option>

                        </ng-container>

                        <mat-option *ngIf="loaders.countries">
                            <mat-spinner diameter="20"></mat-spinner>
                        </mat-option>

                        <mat-option *ngIf="!loaders.countries && !filteredCountries">
                            <span>{{'requiredInfoComponent.noResult'|translate}}</span>
                        </mat-option>

                    </mat-autocomplete>

                    <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('country_name')">
                        <span class="mat-caption">{{'requiredInfoComponent.countryRequired'|translate}}</span>
                    </mat-error>

                </mat-form-field>

                <!-- Postal input -->
                <mat-form-field fxFlex="30">

                    <mat-label>{{'requiredInfoComponent.postalCode'|translate}}</mat-label>

                    <input matInput autocomplete="none|false|no" placeholder="{{'requiredInfoComponent.postalCode'|translate}}" formControlName="postal"
                        #autoCompletePostal (keydown.backspace)="removePostal()">

                    <mat-hint class="mat-caption" *ngIf="unavailablePostal && requiredInfosForm.get('postal').value">
                        {{'requiredInfoComponent.zipfalse'|translate}}</mat-hint>

                    <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('postal')">
                        <span class="mat-caption">  {{'requiredInfoComponent.postalCoderequired'|translate}}</span>
                    </mat-error>

                </mat-form-field>

                <!-- City input -->
                <mat-form-field fxFlex>

                    <mat-label>{{'requiredInfoComponent.city'|translate}}</mat-label>

                    <mat-select placeholder="{{'requiredInfoComponent.city'|translate}}" formControlName="city_name" #selectCities>

                        <mat-option *ngFor="let city of filteredCities" [value]="city.name"
                            (onSelectionChange)="onSelectCity(city)">
                            {{city.name}}
                        </mat-option>

                    </mat-select>

                    <mat-spinner diameter="20" *ngIf="loaders.cities"></mat-spinner>

                    <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('city_name')">
                        <span class="mat-caption">{{'requiredInfoComponent.cityrequired'|translate}}</span>
                    </mat-error>

                </mat-form-field>


            </div>


            <div fxLayout="column" fxLayoutGap="10px">
                <!-- birth -->
                <mat-form-field fxFlex>
                    <mat-label>{{'requiredInfoComponent.Birthday'|translate}}</mat-label>
                    <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                        (keydown.space)="$event.preventDefault()" formControlName="birth">
                    <mat-hint>DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>

                    <!-- <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('birth)">
        <span class="mat-caption">Date de naissance requise</span>
      </mat-error> -->
                </mat-form-field>




                <!-- enable_marketing -->
                <section id="enable_marketing" fxLayout="row" fxLayoutAlign="start center" style="padding:20px 4px ;">

                    <mat-checkbox formControlName="enable_marketing" color="primary" (change)="onChkChange($event)">
                        <span class="mat-subheading-1" ngClass.xs="mat-caption"
                            style="width: 15px">{{"enable_marketing.acceptTerms"|translate}}</span>
                    </mat-checkbox>


                </section>
            </div>



            <!-- Error message -->
            <div fxLayout="row" fxLayoutAlign="center center" class="warn rad-bord layout-padd" *ngIf="errorMessage">
                <span class="mat-subheading-1">{{errorMessage}}</span>
            </div>

        </form>

        <div class="layout-padd-2">

            <button fxFlex color="primary" (click)="submitRequiredInfos()" mat-raised-button angulartics2On="click"
                angularticsAction="submitInfo" angularticsCategory="requiredInformations"
                [disabled]="requiredInfosForm.invalid">
                <span>{{'button.validate'|translate}}</span>
            </button>

        </div>

    </div>

</div>

<app-popup-loader [flagLoading]="loaders.page" [size]="30"></app-popup-loader>
